export default {
  Auth: {
    region: process.env.AWS_DEFAULT_REGION || 'eu-west-1',
    userPoolId: process.env.USER_POOL_ID,
    userPoolWebClientId: process.env.USER_POOL_CLIENT_ID
  }
};
